import MainLayout from 'components/layout/MainLayout';
import BlogArticle from 'components/blog/BlogArticle';
import { ASSET_PREFIX } from 'utils/constants';
import { NextSeo } from "next-seo";
import Link from "next/link";
import { getCta } from 'utils/common';

const TeamTriphuntersFavouritesArticle = () => {
  const IMAGE_DIRECTORY = `${ASSET_PREFIX}/images/blog/articles/team-triphunters-favourites`;

  return (
    <MainLayout>
      <NextSeo
        title="Team DAYMADE's Favourites | DAYMADE"
        description="The DAYMADE team might all be living in the UK, but we’re a pretty international bunch with a love for travel! Fancy getting to know our fave destinations and a little more about us?"
        openGraph={{
          title: "Team DAYMADE's Favourites | DAYMADE",
          description:
            'The DAYMADE team might all be living in the UK, but we’re a pretty international bunch with a love for travel! Fancy getting to know our fave destinations and a little more about us?',
          type: 'article',
          url: 'https://www.daymade.co.uk/blog/team-triphunters-favourites',
          images: [
            {
              url: `${IMAGE_DIRECTORY}/hero.jpg`,
              alt: 'Abbi setting off a Chinese lantern, Callum jumping into some bright blue ocean water, Lisa looking very happy in a Las Vegas casino, Andrew chilling by some tropical palm trees, and Loic skydiving by the coast in South Africa',
            },
          ],
        }}
        // additionalMetaTags={[{
        //   name: 'keywords',
        //   content: 'win,travel,holiday,raffle,beach,lantern,explore,cookery,sunrise,casino,country,snowmobile,roadtrip,sea,sunny,caribbean,japan,chill,sun,sail,snorkel,palm trees,safari,adrenaline,skiing,alps,sky diving,bungie jumping'
        // }]}
      />

      <BlogArticle
        imageDirectory={IMAGE_DIRECTORY}
        heroAltText="Abbi setting off a Chinese lantern, Callum jumping into some bright blue ocean water, Lisa looking very happy in a Las Vegas casino, Andrew chilling by some tropical palm trees, and Loic skydiving by the coast in South Africa"
      >
        <>
          <h1 style={{ fontSize: '1.6em' }}>
            Team DAYMADE's <strong>Favourites</strong>
          </h1>

          <p className="subheading">We're a travel-loving bunch</p>

          <div
            className="separator"
            style={{ width: '80%', marginTop: 0 }}
          />

          <p
            style={{
              fontStyle: 'italic',
              textAlign: 'center',
              marginBottom: '2em',
            }}
          >
            by Abbi James
          </p>

          <p>
            <span className="bigFirstLetter">T</span>he DAYMADE team might all
            be living in the UK, but we’re a pretty international bunch with a
            love for travel! Fancy getting to know our fave destinations and a
            little more about us? Check us out below!
          </p>

          <h4>
            <strong>Abbi</strong>
          </h4>

          <p>
            As the newest member to the laavely DAYMADE team, Abbi’s all about
            trying new experiences and pushing boundaries! She recently set sail
            for the beach life, living it up in sunny Thailand for 6 months
            (back in the good ol’ days before the ‘rona came a-calling!).
          </p>

          <p>
            Asia’s always been a second home to this lil’ explorer. If she could
            be anywhere in the world, she’d whisk herself away to the food and
            street markets of Cambodia and Vietnam, giving her taste palette a
            lesson or two along the way.
          </p>

          <p>
            Japan would be the next port of call, to explore the rich culture of
            this history-steeped nation. The country of contrasts, there’s so
            much to explore! Bathing in onsens, exploring the magical world of
            Studio Ghibli, or chasing the beautiful view of Mount Fuji. Needless
            to say, Abbi’s dream bucketlist trip would be to adventure across
            Asia (taking a pal along too of course!).
          </p>

          <p>
            Her next staycation, however, would have to be staying at Port
            Lympne with giraffes and deer on the doorstep. A spoonful of nature
            and a spoonful of luxury – what more could we ask for after the year
            we’ve all had?
          </p>

          <img
            src={`${IMAGE_DIRECTORY}/abbi.jpg`}
            alt="Abbi cooking some Asian food, Abbi watching the sunrise"
            className="singleBlogImage"
          />

          <h4>
            <strong>Lisa</strong>
          </h4>

          <p>
            Lisa is the OG member of the DAYMADE team and is our resident global
            explorer! Not one to take a kip by the poolside all day, she loves
            to get out and explore across continents. She loves Lapland for the
            Northern Lights and how life there is designed to fit around minimal
            daylight hours. From whale-watching in Norway, to snowmobiling in
            Finland, this traveller loves the cold (and wearing a million
            layers) – nothing a hot chocolate and a lil extra something won’t
            fix.
          </p>

          <p>
            <span style={{ fontStyle: 'italic' }}>
              "My favourite way to explore a new city is by bike and I LOVE
              roadtrips. I also love eating and drinking. It's the best way to
              get to know a new place{' '}
            </span>
            😉"
          </p>

          <p>
            Lisa is so well-versed in the art of travelling that she was
            inspired to add the California Roadtrip Bucketlister prize after a
            similar trip of her own! She visited aaaalllll (yes, all!) the
            National Parks in and around California, before hot-footing it to
            Las Vegas.{' '}
            <span style={{ fontStyle: 'italic' }}>
              “It's a crazy place in the middle of the dessert full with crazy
              people and all the impressions!”
            </span>
          </p>

          <p>
            When she’s not hiking across the Gran Canyon, exploring San
            Francisco or adventuring through LA, Lisa loves to roadtrip through
            Wales with her pals. With everything going on during this crazy
            year, having a beautiful holiday destination so close to home is all
            we could ask for. And whilst there, she’d make the trip extra
            special by staying in a sensational treehouse hotel. I sense a Team
            DAYMADE expedition coming soon, don’t you? 😏
          </p>

          <img
            src={`${IMAGE_DIRECTORY}/lisa.jpg`}
            alt="Lisa riding a snowmobile in Finland, Lisa jumping in the countryside"
            className="singleBlogImage"
          />

          <h4>
            <strong>Callum</strong>
          </h4>

          <p>
            Callum, our Caribbean King, is no stranger to gorgeous white sandy
            beaches and crystal blue waters. We trust him to know the BEST
            places on offer for a little island-living. His personal faves are
            the Grenadines (remember the island Jack Sparrow got marooned on in
            the first Pirates of the Caribbean? That’s there!). When he’s not
            sailing life away on a catamaran, Callum loves exploring the local
            cuisines on his travels.
          </p>

          <p>
            Despite being an expert traveller, one cuisine he’s yet to try
            locally is Japanese! The chance to try steaming fresh udon,
            mouth-watering takoyaki or authentic ramen is just too irresistible
            to many of us! For this reason (among many, let’s be real), Callum
            would love to go on our 2 week cross-country train journey through
            the land of the rising sun.
          </p>

          <p>
            We all know it might be another few months until we can fully relax
            into jetsetting across the world again, but until then, the UK has
            some amazing staycations on offer! Callum’s top choice would be an
            island villa in Cornwall, devouring some next level Cornish Pasties
            (Y.U.M). Who wouldn’t want their own island for a week?!
          </p>

          <p>
            Coming from the land of heavenly rum, Callum’s become somewhat of a
            rum-connoisseur (is that a job? We might be losing him to it if
            we’re not careful!). His fave is Rum Punch from Cutters Bar,
            Barbados (he says he’s not biased, but we might have to go try
            tipple out ourselves just to be sure…).
          </p>

          <img
            src={`${IMAGE_DIRECTORY}/callum.jpg`}
            alt="Callum relaxing on a beach and jumping into the ocean"
            className="singleBlogImage"
          />

          <h4>
            <strong>Andrew</strong>
          </h4>

          <p>
            Andrew is a true globetrotter, having called Germany, Singapore,
            Dubai, USA and London his home over the years.
          </p>

          <p>
            When it comes to hols, Andrew loves a good mix of down-time on the
            beach and action-packed adventure. Anywhere with sun, sand and
            crystal-clear waters, and he’s off like a shot! You’ll catch him
            sampling local foods, seeing the sights by sail, and exploring the
            underworld with snorkel in-tow.
          </p>

          <p>
            If one day we couldn’t find Andrew, he’d probably have jet-setted
            off to the Philippines for his own island-hopping adventure. With
            waterfalls to chase and sharks to swim with, there’s no telling what
            he’d get up to! Wherever he’d be, we can be certain he’d find the
            tastiest local foods to try, perhaps with cocktail in hand? (Or
            two?). When he’s more UK-based, however, Andrew would like to try
            his hand at paddleboarding through the London canals and waterways,
            and see our capital from a different angle…literally!
          </p>

          <img
            src={`${IMAGE_DIRECTORY}/andrew.jpg`}
            alt="Andrew on a safari seeing an elephant, Andrew sitting by the waterfront in a tropical island"
            className="singleBlogImage"
          />

          <h4>
            <strong>Loic</strong>
          </h4>

          <p>
            While Loic enjoys a relaxing beach holiday as much as the next
            person, for him, an ideal holiday involves lots of activities. His
            current fave is skiing in Val D’Isere (with some VERY cool visors
            on). Gracefully falling down ski slopes (or skiing) is just the tip
            of the iceberg – Loic loves extreme sports that whack his adrenaline
            up. He’s already crossed off sky diving in South Africa, and next on
            his bucket list is bungie jumping! This guy has no fears. Whilst
            he’s at it, his next top UK-based staycation would be to stay in the
            glorious bubble domes in Ireland! Who doesn’t love a
            super-Instagrammable getaway on your doorstop?!
          </p>

          <p>
            <span style={{ fontStyle: 'italic' }}>
              "Often, the most exciting kinds of holidays are the ones you don’t
              plan!"
            </span>
          </p>

          <img
            src={`${IMAGE_DIRECTORY}/loic-v.jpg`}
            alt="Loic sky diving in South Africa, Loic skiing in the French Alps"
            className="singleBlogImage"
          />

          <br />

          <p>
            How about you? Are you dreaming of a break full of relaxation, or
            filling up on endless adventure? Whatever your dream holiday might
            be, you can win it with DAYMADE. {''}
            <Link href={getCta()?.url}>
              <a style={{ margin: 0, fontWeight: 'bold' }}>Enter now</a>
            </Link>
            {''}!
          </p>
        </>
      </BlogArticle>
    </MainLayout>
  );
};

export default TeamTriphuntersFavouritesArticle;
